var React = require('react');

function DesignerInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.66732 21.6667C9.58398 21.6667 10.334 22.4167 10.334 23.3333C10.334 25.1667 8.83398 26.6667 7.00065 26.6667C6.71732 26.6667 6.45065 26.6333 6.16732 26.5833C6.68398 25.6667 7.00065 24.5667 7.00065 23.3333C7.00065 22.4167 7.75065 21.6667 8.66732 21.6667ZM28.1173 0C27.684 0 27.2673 0.166667 26.934 0.483333L12.0007 15.4167L16.584 20L31.5173 5.06667C32.1673 4.41667 32.1673 3.36667 31.5173 2.71667L29.284 0.483333C28.9507 0.15 28.534 0 28.1173 0ZM8.66732 18.3333C5.90065 18.3333 3.66732 20.5667 3.66732 23.3333C3.66732 25.5167 1.73398 26.6667 0.333984 26.6667C1.86732 28.7 4.48398 30 7.00065 30C10.684 30 13.6673 27.0167 13.6673 23.3333C13.6673 20.5667 11.434 18.3333 8.66732 18.3333Z","fill":"#FF8F00"}));
}

DesignerInline.defaultProps = {"width":"33","height":"30","viewBox":"0 0 33 30","fill":"none"};

module.exports = DesignerInline;

DesignerInline.default = DesignerInline;
